import { useSetAtom } from "jotai";
import { useMutation } from "@tanstack/react-query";

import TenantAPI from "../../../api/api/TenantAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { newToastEvent } from "../../../utils/ToastUtil";
import { setSchemaAtom } from "../../../atoms/GlobalAtoms";
import { Field, Schema } from "../../../types/TenantInterfaces";

interface CreateModuleI {
  moduleName: string;
  moduleAPIName: string;
  fields: Field[] | undefined;
  addSchema?: boolean;
  dynamicDataSource?: {
    Dynamic: boolean;
    SQLQuery: string;
    GCQuery: string;
  };
  onSuccess?: (schema: Schema) => void;
  onError?: () => void;
}

const useCreateModule = () => {
  const setSchema = useSetAtom(setSchemaAtom);

  const createModule = useMutation({
    mutationFn: ({
      moduleName,
      moduleAPIName,
      fields,
      dynamicDataSource,
    }: CreateModuleI) => {
      return TenantAPI.addCRMModule(
        moduleName,
        moduleAPIName,
        fields,
        dynamicDataSource
      );
    },
    onSuccess: (data, { onSuccess, addSchema }) => {
      const newSchema = data.data.data.schema;

      addSchema && setSchema(newSchema);
      callFunctionIfExists(onSuccess, newSchema);
    },
    onError: (error, { onError }) => {
      callFunctionIfExists(onError);
      newToastEvent(
        "error",
        getErrorMessage(error, "An unknown error occurred. Please try again.")
      );
    },
  });

  return {
    createModule: createModule.mutate,
    loading: createModule.isPending,
    error: createModule.error ? getErrorMessage(createModule.error) : null,
  };
};

export default useCreateModule;
